export const UPDATE_SNACKBAR = 'UPDATE_SNACKBAR';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_MENU_INDEX = 'SET_MENU_INDEX';
export const USER_UNAUTHRIZED = 'USER_UNAUTHRIZED';
export const SET_TERMS_CONDITIONS = 'SET_TERMS_CONDITIONS';
export const SET_IS_REFRESHING_TOKEN = 'SET_IS_REFRESHING_TOKEN';